document.addEventListener("DOMContentLoaded", function () {
    // 定义 matchesMediaQuery 函数，使用 window.matchMedia
    function matchesMediaQuery(query) {
        return window.matchMedia(query).matches;
    }

    class YGInput extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            this.downSubmit()
        }
        downSubmit() {
            const $butn = this.querySelector(".icon")
            const $submit = this.parentElement.querySelector(".align-self-start button[type='submit']")
            $butn.addEventListener("click", function () {
                $submit.click()
            })
        }
    }
    if (!window.customElements.get('yg-input')) {
        window.customElements.define('yg-input', YGInput);
    }

    class YGProductList extends HTMLElement {
        constructor() {
            super();
            this.swiperInstance = null;  // 用来保存Swiper实例
            this.lastWidth = window.innerWidth;  // 初始屏幕宽度
        }

        connectedCallback() {
            this.Slideshow();
            // 监听窗口大小变化
            window.addEventListener('resize', this.onResize.bind(this));
        }

        disconnectedCallback() {
            // 清理事件监听器
            window.removeEventListener('resize', this.onResize.bind(this));
            // 清理Swiper实例
            if (this.swiperInstance) {
                this.swiperInstance.destroy();
                this.swiperInstance = null;
            }
        }

        onResize() {
            const currentWidth = window.innerWidth;

            // 只有当屏幕宽度跨越 700px 这个临界值时才执行
            if ((this.lastWidth <= 700 && currentWidth > 700) || (this.lastWidth > 700 && currentWidth <= 700)) {
                this.Slideshow(); // 屏幕宽度变动，重新检查并更新Swiper
            }

            // 更新当前宽度
            this.lastWidth = currentWidth;
        }

        Slideshow() {
            const $count = this.dataset.count;
            const $grid = this.classList.contains("yg-list-grid");
            const $width = window.innerWidth < 700;  // 判断是否为移动端
            // 如果在移动端并且是 grid，禁用Swiper
            if ($width && $grid) {
                // 如果已经有Swiper实例，则销毁它
                if (this.swiperInstance) {
                    this.swiperInstance.destroy();
                    this.swiperInstance = null;
                }
            } else {
                // 如果是PC端或者移动端但不是grid
                if (!this.swiperInstance) {
                    this.swiperInstance = new Swiper(this, {
                        slidesPerView: 1.2,
                        spaceBetween: 15,
                        breakpoints: {
                            390: {
                                slidesPerView: 1.2,
                                spaceBetween: 14,
                            },
                            700: {
                                slidesPerView: $count,
                                spaceBetween: 24,
                            },
                        },
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        }
                    });
                }
            }
        }
    }

    // 定义自定义元素
    if (!window.customElements.get('yg-product-list')) {
        window.customElements.define('yg-product-list', YGProductList);
    }


    class YGSwatchColor extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            this.hrefLink()
        }
        hrefLink() {
            const $butn = this.querySelectorAll(".h-stack .yg-product-link")
            let firstClickOccurred = false;
            // 设置开始时禁止点击，当用户点击任意位置之后开始绑定事件
            document.addEventListener('click', function () {
                if (!firstClickOccurred) {
                    firstClickOccurred = true;

                    $butn.forEach(el => {
                        el.addEventListener('click', function () {
                            window.location.href = el.getAttribute('href');
                        });
                    });
                }
            });
        }
    }
    if (!window.customElements.get('yg-swatch-color')) {
        window.customElements.define('yg-swatch-color', YGSwatchColor);
    }

    class YGCollections extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            this.swiper()
        }
        swiper() {
            const $swiper = this.querySelector(".swiper")
            const $count = this.getAttribute("yg-count")
            new Swiper($swiper, {
                slidesPerView: 1.5,
                spaceBetween: 15,
                breakpoints: {
                    390: {
                        slidesPerView: 1.5,
                        spaceBetween: 14,
                    },
                    700: {
                        slidesPerView: $count,
                        spaceBetween: 24,
                    },
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            })
        }
    }
    if (!window.customElements.get('yg-collections')) {
        window.customElements.define('yg-collections', YGCollections);
    }

    class YGText extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            this.openText()
            requestAnimationFrame(() => this.openText())

            if (document.fonts && document.fonts.ready && !this.fontReadyChecked) {
                this.fontReadyChecked = true
                document.fonts.ready.then(() => {
                    if (this.isConnected) {
                        this.openText()
                    }
                })
            }
        }
        getRenderedLineCount($box, lineHeight) {
            const range = document.createRange()
            range.selectNodeContents($box)

            const threshold = Math.max(2, lineHeight / 2.2)
            const lines = []
            Array.from(range.getClientRects()).forEach((rect) => {
                if (rect.width <= 0 || rect.height <= 0) return

                const center = rect.top + rect.height / 2
                const hasLine = lines.some((lineCenter) => Math.abs(lineCenter - center) < threshold)
                if (!hasLine) {
                    lines.push(center)
                }
            })

            range.detach()

            return lines.length
        }
        openText() {
            const $box = this.querySelector(".yg-info")
            const more = this.querySelector(".yg-more")
            if (!$box || !more) return

            const $count = parseInt(this.dataset.count, 10)
            if (!$count) return

            const boxStyle = getComputedStyle($box)
            const height = parseFloat(boxStyle.lineHeight) || parseFloat(boxStyle.fontSize)
            const maxheight = height * $count
            const $Clamp = this.dataset.clamp
            const wasOpen = $box.classList.contains("open")

            $box.style.maxHeight = "none"
            $box.style.webkitLineClamp = "unset"
            more.onclick = null

            const lineCount = this.getRenderedLineCount($box, height)
            const hasMoreContent = lineCount ? lineCount > $count : $box.scrollHeight - maxheight > 8

            if (hasMoreContent) {
                if (wasOpen) {
                    $box.style.maxHeight = $box.scrollHeight + "px"
                    $box.style.webkitLineClamp = "unset"
                    more.innerHTML = "Show Less"
                } else {
                    $box.style.maxHeight = maxheight + "px"
                    if ($Clamp) {
                        $box.style.webkitLineClamp = `${$Clamp}`;
                    }
                    more.innerHTML = "Read More"
                }

                more.style.display = "inline-block"
                more.onclick = function (event) {
                    event.preventDefault();
                    if ($box.classList.contains("open")) {
                        $box.style.maxHeight = maxheight + "px";
                        $box.classList.remove("open")
                        more.innerHTML = "Read More"
                        setTimeout(() => {
                            if ($Clamp) {
                                $box.style.webkitLineClamp = `${$Clamp}`;
                            }
                        }, 500);
                    } else {
                        $box.style.maxHeight = $box.scrollHeight + "px"
                        $box.classList.add("open")
                        $box.style.webkitLineClamp = 'unset';
                        more.innerHTML = "Show Less"
                    }
                }
            } else {
                $box.classList.remove("open")
                $box.style.maxHeight = "none"
                $box.style.webkitLineClamp = "unset"
                more.style.display = "none"
            }

        }
    }
    if (!window.customElements.get('yg-text')) {
        window.customElements.define('yg-text', YGText);
    }

    class YGProductToggle extends HTMLElement {
        constructor() {
            super();
            this.index = 0;
        }

        connectedCallback() {
            this.toggle();
        }

        toggle() {
            this.$tabs = this.parentElement.querySelectorAll(".page-dots button");
            const container = this;
            if(container.closest(".complementary-products")) {
                this.$tabs2 = container.closest(".complementary-products").querySelectorAll(".v-stack .page-dots button");
                console.log('tabs2',this.$tabs2);
                
            }
            
            this.$leftBtn = this.querySelector(".yg-btn-left");
            this.$rightBtn = this.querySelector(".yg-btn-right");
            if ((!this.$tabs.length && !this.$tabs2.length) || !this.$leftBtn || !this.$rightBtn) return;

            this.updateButtonIndex()

            // this.updateButtonVisibility();

            this.$leftBtn.addEventListener("click", () => this.handleLeftClick());
            this.$rightBtn.addEventListener("click", () => this.handleRightClick());
        }

        handleLeftClick() {
            console.log('handleLeftClick');
            
            this.updateButtonIndex()
            if (this.index > 0) {
                this.index--;
                if(this.$tabs.length > 0) {
                    this.$tabs[this.index].click();
                }
                if(this.$tabs2) {
                    console.log(11111);
                    
                    this.$tabs2[this.index].click();
                }
                // this.updateButtonVisibility();
            } else {
                if(this.$tabs.length > 0) {
                    this.index = this.$tabs.length - 1;
                } else if(this.$tabs2.length > 0) {
                    this.index = this.$tabs2.length - 1;
                }
                
                if(this.$tabs.length > 0) {
                    this.$tabs[this.index].click();
                }
                if(this.$tabs2) {
                    this.$tabs2[this.index].click();
                }
            }
        }

        handleRightClick() {
            console.log('handleRightClick');
            
            this.updateButtonIndex()
            if ((this.index < this.$tabs.length - 1) || (this.index < this.$tabs2.length - 1)) {
                this.index++;
                if(this.$tabs.length > 0) {
                    this.$tabs[this.index].click();
                }
                if(this.$tabs2) {
                    this.$tabs2[this.index].click();
                }
                // this.updateButtonVisibility();
            } else {
                this.index = 0;
                if(this.$tabs.length > 0) {
                    this.$tabs[this.index].click();
                }
                if(this.$tabs2) {
                    this.$tabs2[this.index].click();
                }
            }
        }

        updateButtonVisibility() {
            this.$leftBtn.classList.toggle("display", this.index === 0);
            this.$rightBtn.classList.toggle("display", this.index === this.$tabs.length - 1);
        }
        updateButtonIndex() {
            if(this.$tabs.length > 0) { 
                this.$tabs.forEach((btn, idx) => {
                    if (btn.getAttribute("aria-current") === "true") {
                        this.index = idx;
                    }
                });
            }
            else if(this.$tabs2) {
                this.$tabs2.forEach((btn, idx) => {
                    if (btn.getAttribute("aria-current") === "true") {
                        console.log('22222',idx);
                        
                        this.index = idx;
                    }
                });
            }

            // this.updateButtonVisibility()
        }
    }

    if (!window.customElements.get('yg-product-toggle')) {
        window.customElements.define('yg-product-toggle', YGProductToggle);
    }
    class YGValues extends HTMLElement {
        constructor() {
            super()
        }
        connectedCallback() {
            this.openText()
        }
        openText() {
            const $box = this.querySelector(".yg-value")
            const more = this.querySelector(".yg-more")
            if (!$box) return

            const $items = Array.from($box.querySelectorAll("li"))
            const $count = parseInt(this.dataset.count, 10)
            if (!$items.length || !$count) return

            const maxheight = $items.slice(0, $count).reduce((height, $item) => height + $item.offsetHeight, 0)
            if ($items.length > $count) {
                $box.style.maxHeight = maxheight + "px"
                if (!more) return

                more.style.display = "inline-block"
                more.addEventListener("click", function (event) {
                    event.preventDefault();
                    if ($box.classList.contains("open")) {
                        $box.style.maxHeight = maxheight + "px";
                        $box.classList.remove("open")
                        more.innerHTML = "Read More"
                    } else {
                        $box.style.maxHeight = $box.scrollHeight + "px"
                        $box.classList.add("open")
                        more.innerHTML = "Show Less"
                    }
                })
            } else {
                $box.style.maxHeight = "none"
                if (more) {
                    more.style.display = "none"
                }
            }

        }
    }
    if (!window.customElements.get('yg-values')) {
        window.customElements.define('yg-values', YGValues);
    }


    class YGRevolving extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            this.Slideshow();
        }
        Slideshow() {
            const $swiper = this.querySelector(".swiper")
            const $count = $swiper.dataset.count;
            const swiper = new Swiper($swiper, {
                slidesPerView: $count,
                spaceBetween: 15,
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            });
            swiper.update();
        }
    }

    if (!window.customElements.get('yg-revolving')) {
        window.customElements.define('yg-revolving', YGRevolving);
    }

    class YGVariantSelect extends HTMLElement {
        constructor() {
            super()
            this.$selects = this.querySelectorAll('.yg-variant')
            this.$quantityInput = this.querySelector('.quantity-selector__input')
            this.$mainQuantityInput = this.closest(`.shopify-section--main-product`).querySelector(".quantity-selector__input")
        }
        connectedCallback() {
            this.$selects.forEach(($select) => {
                $select.addEventListener('click', this.itemClick.bind(this));
            })

            document.addEventListener("click", (e) => {
                if (!this.isTargetDom(e.target, '.yg-variant')) {
                    this.$selects.forEach(($select) => {
                        $select.classList.remove('active')
                    })
                }
            })

            this.$quantityInput.addEventListener("change", this.quantityChange.bind(this))
            this.$mainQuantityInput.addEventListener("change", this.quantityChange.bind(this))
        }

        disconnectedCallback() {
            this.$selects.forEach(($select) => {
                $select.removeEventListener('click', this.itemClick.bind(this));
            })

            this.$quantityInput.removeEventListener("change", this.quantityChange.bind(this))
            this.$mainQuantityInput.removeEventListener("change", this.quantityChange.bind(this))
        }

        itemClick(e) {
            // 这里放置自定义逻辑
            let $select = this.isTargetDom(e.target, '.yg-variant')
            let $label = this.isTargetDom(e.target, '.yg-variant-select__options')
            if (!$label) this.targetDom($select, 'active')

            let $option = this.isTargetDom(e.target, '.yg-option')
            if ($option) this.changeVariant($option, $select)
        }

        isTargetDom($clickDom, className) {
            // 检查传入的元素是否有效
            if (!$clickDom || !className) {
                return false;
            }

            if ($clickDom.closest(`${className}`)) return $clickDom.closest(`${className}`)

            return false
        }

        targetDom($clickDom, className) {
            this.$selects.forEach(($select) => {
                if ($select !== $clickDom) $select.classList.remove(className)
            })
            $clickDom.classList.toggle(className)
        }

        changeVariant($option, $select) {
            let $selectLabel = $select.querySelector(".yg-variant-label")
            let $optionValue = $option.getAttribute('data-value')

            if ($selectLabel.getAttribute('data-value') === $optionValue) return

            let $variantPicker = this.closest(`.shopify-section--main-product`).querySelector("variant-picker.variant-picker")
            if ($variantPicker) {
                let $fieldsetList = $variantPicker.querySelectorAll(`fieldset.variant-picker__option`)
                let $fieldset = $variantPicker.querySelector(`fieldset.variant-picker__option[data-variant='${$selectLabel.getAttribute("data-variant")}']`)
                let optionValues = []

                let $optionInput = $fieldset.querySelector(`label[data-option='${$optionValue}']`).previousElementSibling

                $fieldsetList.forEach(($item) => {
                    if ($item !== $fieldset) {
                        optionValues.push($item.querySelector("input[checked='checked']").value)
                    } else {
                        optionValues.push($optionInput.value)
                    }
                })
                $variantPicker.selectCombination({
                    optionValues: optionValues,
                    productChange: $optionInput.hasAttribute("data-product-url")
                });
            }
        }

        quantityChange(e) {
            this.$mainQuantityInput = this.closest(`.shopify-section--main-product`).querySelector(".quantity-selector__input")
            this.$quantityInput.value = e.target.value
            this.$mainQuantityInput.value = e.target.value
        }
    }
    if (!window.customElements.get('yg-variant-select')) {
        window.customElements.define('yg-variant-select', YGVariantSelect)
    }

    const $zoomIn = document.querySelector('.product-gallery__zoom-button')
    if($zoomIn) {
        $zoomIn.addEventListener('click', function () {
            setTimeout(() => {
                const $zoom = document.querySelector('.pswp__scroll-wrap')
                $zoom.addEventListener('click', function (e) {
                    if(!e.target.closest('img') && !e.target.closest('[aria-label="Next"]') && !e.target.closest('[aria-label="Previous"]')) {
                        const $closeBtn = document.querySelector('button[aria-label="Close gallery"]');
                        $closeBtn.click();
                    }
                })
                
            }, 500)
            
            
        })
        
    }

    function isElementVisible(el, options = {}) {
        const {
            partial = false,   // 是否部分可见
            threshold = 0.1    // 可见比例阈值（0-1）
        } = options;

        const rect = el.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth;

        // 计算可见区域的交集
        const visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
        const visibleWidth = Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0);

        // 可见面积计算
        const elementArea = rect.width * rect.height;
        const visibleArea = visibleHeight * visibleWidth;

        return partial 
            ? visibleArea > 0  // 至少部分可见
            : (visibleArea / elementArea) >= threshold; // 可见比例达到阈值
    }
    function MotionEffect() {
        const $sections = document.querySelectorAll('.shopify-section');
        const $headers = document.querySelectorAll('.prose :is(h1,h2,h3,h4,h5,h6,.h1,.h2,.h3.h4.h5.h6,.heading)');
        $sections.forEach(($section) => {
            if(isElementVisible($section,{ threshold: 0.2 })) $section.classList.add('yg-active')
        })
        $headers.forEach(($header) => {
            if(isElementVisible($header,{ threshold: 0.5 })) $header.classList.add('yg-active')
        })
        
    }

    MotionEffect();
    window.addEventListener('scroll', function () {
        MotionEffect();
    });
})
